<template>
  <div class="wzbright">
    <div class="right-title">支部活动</div>
    <!-- 支部信息 -->
    <div class="right-info">
      <div>
        查看
        <span class="info-num">{{partyActive.chakan}}</span>
      </div>
      <div>
        评论
        <span class="info-num">{{partyActive.pinglun}}</span>
      </div>
      <div>
        报名
        <span class="info-num last-num">{{partyActive.baoming}}</span>
      </div>
    </div>
    <!-- 支部活动封面 -->
    <img class="right-pic" v-if="partyActive.cover" :src="partyActive.cover" />
    <!-- 活动标题 -->
    <div class="wzb-active">{{partyActive.title}}</div>
    <!-- 报名人员 -->
    <div class="act-sign">
      <div v-for="(item,index) in baomingMember" :key="index" class="act-sign_item">
        <img class="act-sign_item-avatar" :src="item.pic" />
        <div class="act-sign_item-info">
          <div class="act-sign_item-info_name">{{item.name}}</div>
          <div class="act-sign_item-info_time">{{item.time}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  props: {
    height: Number,
    width: Number,
    partyActive: {
      type: Object,
      default: () => {}
    },
    baomingMember: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="less" scoped>
.wzbright {
  height: 100%;
  position: relative;
}
.right-title {
  text-align: center;
  font-size: 0.28rem;
  font-weight: 600;
  color: #4c4c4c;
}
.right-info {
  .flex(center, center);
  color: #000;
  padding: 0.24rem 0;
  font-size: 0.18rem;
}
.info-num {
  margin: 0 0.35rem 0 0.1rem;
}
.last-num {
  margin-right: 0;
}
.right-pic {
  width: 100%;
  height: auto;
}
.wzb-active {
  color: #333;
  font-size: 0.25rem;
  line-height: 1.3;
  padding-top: 20px;
}
.act-sign {
  .flex(@justifyContent:space-between, @flexWrap:wrap);
}
.act-sign_item {
  .flex();
  margin-top: 0.34rem;
}
.act-sign_item-avatar {
  width: 0.6rem;
  height: 0.6rem;
  margin-right: 0.1rem;
  border-radius: 50%;
}
.act-sign_item-info {
  .flex(flex-start, space-between, @flexDirection:column);
  color: #4c4c4c;
}
.act-sign_item-info_name {
  font-size: 0.22rem;
}
.act-sign_item-info_time {
  font-size: 0.19rem;
  color: #999;
}
</style>
